export const SETTINGS_PERMISSIONS_COLUMNS = [
  { key: "full_access", label: "Full Access" },
  { key: "create", label: "Create" },
  { key: "view", label: "View" },
  { key: "edit", label: "Edit/Update" },
  { key: "delete", label: "Delete/Deactivate" }
] as const
